const LoadingIndicator = () => <p>Loading...</p>;

export default LoadingIndicator;
